import { render, staticRenderFns } from "./bargain.vue?vue&type=template&id=652b4993&scoped=true"
import script from "./bargain.vue?vue&type=script&lang=js"
export * from "./bargain.vue?vue&type=script&lang=js"
import style0 from "./bargain.vue?vue&type=style&index=0&id=652b4993&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652b4993",
  null
  
)

component.options.__file = "bargain.vue"
export default component.exports